import React from 'react';
import PropTypes from 'prop-types';

import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';

import '../styles/main.scss';

const DefaultLayout = ({ children }) => (
  <div className="site-container">
    <section>
      <h2 className="is-sr">Skip links</h2>
      <ul>
        <li>
          <a href="#nav-primary" className="is-sr">
            Skip to primary navigation
          </a>
        </li>
        <li>
          <a href="#site-main" className="is-sr">
            Skip to content
          </a>
        </li>
        <li>
          <a href="#site-footer" className="is-sr">
            Skip to footer
          </a>
        </li>
      </ul>
    </section>
    <SiteHeader />
    <main id="site-main" className="site-main">
      {children()}
    </main>
    <SiteFooter />
  </div>
);

DefaultLayout.defaultProps = {
  children: () => {},
};

DefaultLayout.propTypes = {
  children: PropTypes.func,
};

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/layouts/index.js